import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard  {

    private router: Router = inject(Router);
    private oauthService: OAuthService = inject(OAuthService);

    canActivate(): Promise<boolean> {
        const haveAccessToken = this.oauthService.hasValidAccessToken();

        return new Promise((resolve) => {
            if (haveAccessToken) {
                resolve(true);
            } else {
                this.router.navigate(['authentication']);
                resolve(false);
            }
        });
    }

}